import { useState } from 'react';
import { Button, CloseButton, Drawer, Flex, HStack, Portal, Text } from '@chakra-ui/react';
import { BaseFields, FormComponents } from '@cks-internal/react-base';
import { UseDisclosureReturn } from '@chakra-ui/react';

type Props = {
  disclosure: UseDisclosureReturn;
  setSearchValue: (value: string) => void;
};

export const MobileSearchOverlay = ({ disclosure, setSearchValue }: Props) => {
  const [inputValue, setInputValue] = useState('');

  const handleApply = () => {
    setSearchValue(inputValue);
    disclosure.onClose();
  };

  const handleClear = () => {
    setInputValue('');
    setSearchValue('');
    disclosure.onClose();
  };

  return (
    <Drawer.Root
      open={disclosure.open}
      onOpenChange={(e) => (e.open ? disclosure.onOpen() : disclosure.onClose())}
      placement='bottom'>
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content roundedTop='2xl' maxH='90vh'>
            <Drawer.Header borderBottomWidth='1px'>
              <Flex align='center' justify='space-between' width='full'>
                <Drawer.Title fontSize='lg' fontWeight='semibold'>
                  Search Products
                </Drawer.Title>
                <Drawer.CloseTrigger asChild position='static'>
                  <CloseButton size='sm' />
                </Drawer.CloseTrigger>
              </Flex>
            </Drawer.Header>
            <Drawer.Body py='4'>
              <Text fontSize='sm' color='gray.600' mb='3'>
                Search by product name, ingredient, or form
              </Text>
              <FormComponents.FormFieldContainer invalid={false}>
                <BaseFields.GenericInput
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  placeholder='Enter search term...'
                  variant='subtle'
                  size='lg'
                />
              </FormComponents.FormFieldContainer>
            </Drawer.Body>
            <Drawer.Footer borderTopWidth='1px' pt='4'>
              <HStack width='full' gap='3'>
                <Button variant='outline' flex='1' size='lg' onClick={handleClear}>
                  Clear
                </Button>
                <Button colorPalette='blue' flex='2' size='lg' onClick={handleApply}>
                  Apply Search
                </Button>
              </HStack>
            </Drawer.Footer>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
};
